import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "fill-rule": "nonzero" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M8.724 3.553A1 1 0 0 1 9.618 3h4.764a1 1 0 0 1 .894.553L16.5 6h4A1.5 1.5 0 0 1 22 7.5v12a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 19.5v-12A1.5 1.5 0 0 1 3.5 6h4z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFF",
    d: "M12 17.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M12 16a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }